enum DefaultViews {
  periodic,
  details,
}
export default DefaultViews;
